import EditTenantInfoPageContainer from './container';

export default EditTenantInfoPageContainer;
